import React, {useEffect, useState} from "react";
import {useDispatch} from "react-redux";
import {
    Form,
    notification,
} from "../../components/Elements/appUtils";
import PageHeader from "../../components/Elements/pageHeader";
import {useNavigate} from "react-router-dom";
import {GetEachFormFields} from "../../components/_utils/formUtils";
import {addUserFxn, getSingleUserFxn, updateUserFxn} from "./actions";
import {sanitizeUserNameInput, vegNonVeg, designationList} from "../../components/_utils/_utils";
import {tableListFxn} from "../pos/actions";
import {singleProductFxn} from "../products/actions";
import {getToken} from "../../request";

/*const designationList = [
    {label: "Select Designation", value: ""},
    {label: "MD", value: "MD"},
    {label: "GM", value: "GM"},
    {label: "F&B Manager", value: "F&B Manager"},
    {label: "HOD", value: "HOD"},
    {label: "Cashier", value: "Cashier"},
    {label: "ARM", value: "ARM"},
    {label: "Captain", value: "Captain"},
    {label: "Steward", value: "Steward"}
];*/

let initState = {
    name: "",
    // email: "",
    loginId: "",
    password: "",
    confirmPassword: "",
    // address: "",
    designation: ""
}

function EditUser(props) {
    let dispatch = useDispatch()
    const navigate = useNavigate();
    let [state, setState] = useState(initState)
    const [userId, setUserId] = useState("");
    let id;
    let events = {
        _updateState: (data) => {
            setState((prevState) => {
                return {
                    ...prevState,
                    ...data
                }
            })
        }
    }

    const handleSubmit = async (e) => {
        const {form} = props;
        e.preventDefault();
        form.validateFields(async (err, valData) => {
            if (!err) {
                valData._id = userId
                if (!valData.name) {
                    notification.warning({message: "Enter Name"});
                    return;
                }
                // if (!valData.email) {
                //     notification.warning({message: "Choose email"});
                //     return;
                // }
                if (!valData.loginId) {
                    notification.warning({message: "Choose email / username"});
                    return;
                }
                if (valData.password || valData.confirmPassword) {
                    if (!valData.password) {
                        notification.warning({message: "Enter password"});
                        return;
                    }

                    if (!valData.confirmPassword) {
                        notification.warning({message: "Enter confirm password"});
                        return;
                    }

                    if (valData.password !== valData.confirmPassword) {
                        notification.warning({message: "Password and confirm password do not match"});
                        return;
                    }
                }
                console.log(valData, "valdata")
                // let x = await dispatch(updateUserFxn({...valData, userType: "captain"}));
                // let x = await dispatch(updateUserFxn({
                //     ...valData,
                //     _id: userId,
                //     email: valData.loginId,
                //     userType: valData.designation
                // }));
                let payload = {
                    ...valData,
                    _id: userId,
                    email: valData.loginId,
                    userType: valData.designation
                };

                if (!payload.password) {
                    delete payload.password;
                }

                delete payload.confirmPassword;

                let x = await dispatch(updateUserFxn(payload));
                // if (x && x.success) {
                //     navigate("/user-list")
                // }
                if (x && x.success) {
                    setTimeout(() => {
                        navigate("/user-list");
                    }, 300);
                }
            }
        });
    };

    const checkUserId = async () => {
        let searchParams = new URLSearchParams(window.location.search);
        id = searchParams.get("_id");
        if (id) {
            getSingleUser(id);
            setUserId(id);
        }
    };
    const getSingleUser = async (id) => {
        let {data, success} = await dispatch(getSingleUserFxn(id), getToken());
        if (success) {
            setTimeout(() => {
                props.form.setFieldsValue({
                    name: data.name,
                    loginId: data.email,
                    designation: data.userType
                    // tables: data.tables,
                    // address: data.address
                })
            }, 300);
        }
    };

    let [tableList, setTableList] = useState([])
    let loadTables = async () => {
        let {data} = await tableListFxn();
        setTableList(data);
    }
    useEffect(() => {
        loadTables()
    }, [])

    let inputTypes = {
        fields: [
            {
                key: "name",
                label: "Name *",
                span: "col-md-4",
                required: true
            },
            {
                key: "loginId",
                label: "Email / Username *",
                span: "col-md-4",
                required: true,
                onChange: ({target}) => {
                    props.form.setFieldsValue({
                        loginId: sanitizeUserNameInput(target.value),
                    });
                }
            },
            {
                key: "designation",
                label: "Designation *",
                span: "col-md-4",
                required: true,
                message: "Please select the designation",
                type: "select",
                options: designationList,
                keyAccessor: (x) => x.value,
                valueAccessor: (x) => x.label,
                onChange: (x) => {
                    props.form.setFieldsValue({
                        designation: x,
                    });
                }
            },
            {
                key: "password",
                label: "Password",
                span: "col-md-4",
                type: "password",
                placeholder: "Leave blank to keep current password"
            },
            {
                key: "confirmPassword",
                label: "Confirm Password",
                span: "col-md-4",
                type: "password",
                placeholder: "Re-enter new password"
            },
            // {
            //     key: "tables",
            //     label: "Tables",
            //     span: "col-md-4",
            //     type: "select",
            //     options: tableList,
            //     showSearch: true,
            //     multiple: true,
            //     keyAccessor: (x) => x.name,
            //     valueAccessor: (x) => `${x.name}`,
            //     onChange: (x) => {
            //         props.form.setFieldsValue({
            //             tables: x,
            //         });
            //     },
            // },
            // {
            //     key: "address",
            //     label: "Address *",
            //     span: "col-md-12"
            // },

        ],
    };

    useEffect(() => {
        checkUserId();
    }, []);

    return (
        <PageHeader title={"Edit User"}>
            <Form onSubmit={handleSubmit}>
                <div className="form-elements-wrapper">
                    <div className="card-body">
                        <div className={"row"}>
                            {inputTypes.fields.map((item, key) => {
                                return !item.hidden ? (
                                    <div className={`${item.span ? item.span : "col-md-6"}`}
                                         key={key}>
                                        <GetEachFormFields {...props.form} item={item}/>
                                    </div>
                                ) : null;
                            })}
                        </div>
                        <div className={'row'}>
                            <div className={'col-md-12'}>
                                <button type="submit" className="btn btn-primary">
                                    Submit
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-secondary ms-2"
                                    onClick={() => navigate("/user-list")}
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>


            </Form>
        </PageHeader>
    );
}

export default Form.create()(EditUser);
